import request from "@/shared/api/request";
import { DEFAULT_PAGE_SIZE } from "@/shared/constants/pagination";

import type {
  FlowRule,
  FlowRuleDraft,
  ListFlowRulesReply,
  ListFlowRunsParams,
  ListFlowRunsReply,
  UpdateFlowRuleRequest,
} from "./types";

const FLOW_RULES_PATH = "/api/v1/flow-rules";

export const listFlowRules = (): Promise<ListFlowRulesReply> =>
  request.get(FLOW_RULES_PATH);

export const getFlowRule = (id: string): Promise<FlowRule> =>
  request.get(`${FLOW_RULES_PATH}/${id}`);

export const createFlowRule = (data: FlowRuleDraft): Promise<FlowRule> =>
  request.post(FLOW_RULES_PATH, data);

export const updateFlowRule = (
  id: string,
  data: UpdateFlowRuleRequest,
): Promise<FlowRule> => request.put(`${FLOW_RULES_PATH}/${id}`, data);

export const deleteFlowRule = (id: string): Promise<Record<string, never>> =>
  request.delete(`${FLOW_RULES_PATH}/${id}`);

export const listFlowRunsByRule = (
  flowRuleId: string,
  params: ListFlowRunsParams = {},
): Promise<ListFlowRunsReply> =>
  request.get(`${FLOW_RULES_PATH}/${flowRuleId}/runs`, {
    page: params.page ?? 1,
    limit: params.limit ?? DEFAULT_PAGE_SIZE,
  });

export const listFlowRunsByItem = (
  itemId: string,
  params: ListFlowRunsParams = {},
): Promise<ListFlowRunsReply> =>
  request.get(`/api/v1/items/${itemId}/flow-runs`, {
    page: params.page ?? 1,
    limit: params.limit ?? DEFAULT_PAGE_SIZE,
  });

